import React from "react";
import { useSelector } from "react-redux";
import * as selector from "store/selectors/assistantPages";
import { Box } from "@mui/material";
import AssistantPageDetails from "../AssistantPageDetails/AssistantPageDetails";
import { TextGroup } from "components/TextGroup";
import { titleStyles, valueStyles } from "config/constants";

const ViewAssistantPageInfo = () => {
  const {
    limits: { basic, pro, team },
  } = useSelector(selector.assistantPage);
  const isLoading = useSelector(selector.isLoading);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        mb: "30px",
      }}
    >
      <AssistantPageDetails title="Basic">
        <TextGroup
          title="View Property Access"
          value={basic.enabled ? "Enabled" : "Disabled"}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
        <TextGroup
          title="Maximum Properties"
          value={basic.maxProperties}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
        <TextGroup
          title="Maximum Rows per Scope"
          value={basic.maxRowsPerScope}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
      </AssistantPageDetails>

      <AssistantPageDetails title="Pro">
        <TextGroup
          title="View Property Access"
          value={pro.enabled ? "Enabled" : "Disabled"}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
        <TextGroup
          title="Maximum Properties"
          value={pro.maxProperties}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
        <TextGroup
          title="Maximum Rows per Scope"
          value={pro.maxRowsPerScope}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
      </AssistantPageDetails>

      <AssistantPageDetails title="Team">
        <TextGroup
          title="View Property Access"
          value={team.enabled ? "Enabled" : "Disabled"}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
        <TextGroup
          title="Maximum Properties"
          value={team.maxProperties}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
        <TextGroup
          title="Maximum Rows per Scope"
          value={team.maxRowsPerScope}
          boxStyle={{
            mb: "30px",
          }}
          titleStyles={titleStyles}
          valueStyles={valueStyles}
          isLoading={isLoading}
        />
      </AssistantPageDetails>
    </Box>
  );
};

export default ViewAssistantPageInfo;
